module.exports = __webpack_public_path__ + "static/media/PHYSICAL_COURSE_SMALL.1eda647a.jpg";